import { h } from "@stencil/core";

export function getResourceIcon(name: string) {
  const icons = {
    car: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16.625">
        <path
          d="M17.471-9.337,16.25-13a3.564,3.564,0,0,0-3.38-2.437H6.13A3.564,3.564,0,0,0,2.751-13L1.529-9.337A2.368,2.368,0,0,0,0-7.125V0A1.188,1.188,0,0,0,1.187,1.188H2.375A1.188,1.188,0,0,0,3.562,0V-1.781H15.437V0a1.188,1.188,0,0,0,1.187,1.188h1.188A1.188,1.188,0,0,0,19,0V-7.125a2.371,2.371,0,0,0-1.529-2.212ZM5-12.25a1.189,1.189,0,0,1,1.128-.813H12.87A1.186,1.186,0,0,1,14-12.251L14.914-9.5H4.086L5-12.25Zm-1.44,7.5A1.188,1.188,0,0,1,2.375-5.937,1.188,1.188,0,0,1,3.562-7.125,1.188,1.188,0,0,1,4.75-5.937,1.186,1.186,0,0,1,3.562-4.75ZM14.25-5.937a1.188,1.188,0,0,1,1.188-1.187,1.188,1.188,0,0,1,1.187,1.188A1.188,1.188,0,0,1,15.437-4.75,1.187,1.187,0,0,1,14.25-5.937Z"
          transform="translate(0 15.438)"
        />
      </svg>
    ),
    battery: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.375 16.626">
        <path
          d="M14.766-7.492a.931.931,0,0,0-.813-.523H11.361L13.6-14.246a.891.891,0,0,0-.385-1.068.892.892,0,0,0-1.123.178L5.565-7.714a.9.9,0,0,0-.144.957.859.859,0,0,0,.813.523H8.826L6.583,0a.891.891,0,0,0,.385,1.068.9.9,0,0,0,.453.123.894.894,0,0,0,.669-.3l6.531-7.422A.888.888,0,0,0,14.766-7.492Zm-12.391-3.2H5.809L7.9-13.062H2.375A2.376,2.376,0,0,0,0-10.687v7.125A2.375,2.375,0,0,0,2.375-1.187H5.116l.855-2.375h-3.6ZM20.188-9.5v-1.187a2.375,2.375,0,0,0-2.375-2.375H15.071l-.855,2.375h3.6v7.125H14.378l-2.09,2.375h5.525a2.375,2.375,0,0,0,2.375-2.375V-4.75a1.188,1.188,0,0,0,1.188-1.187V-8.312A1.186,1.186,0,0,0,20.188-9.5Z"
          transform="translate(0 15.438)"
        />
      </svg>
    ),
    fire: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.625 19">
        <path
          d="M12-14.723A22.254,22.254,0,0,0,9.923-12.5a29.151,29.151,0,0,0-3.689-4.123C2.588-13.244,0-8.832,0-6.175a8.43,8.43,0,0,0,8.313,8.55,8.43,8.43,0,0,0,8.313-8.55C16.625-8.149,14.7-12.228,12-14.723Zm-.72,12.641a5,5,0,0,1-2.865.894A4.571,4.571,0,0,1,3.563-5.834c0-1.434.9-2.7,2.7-4.854.26.3,3.669,4.654,3.669,4.654l2.176-2.482c.153.25.292.5.417.738a4.425,4.425,0,0,1-1.239,5.7Z"
          transform="translate(0 16.625)"
        />
      </svg>
    ),
    recycle: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16.625">
        <path
          d="M5.908-11a.6.6,0,0,0-.716-.447L1.8-10.662a.893.893,0,0,0-.272,1.625l.9.568L.545-5.447A3.563,3.563,0,0,0,3.568,0H4.753A1.19,1.19,0,0,0,5.939-1.189,1.187,1.187,0,0,0,4.753-2.375H3.564A1.188,1.188,0,0,1,2.557-4.192L4.446-7.214l.9.564A.89.89,0,0,0,6.687-7.6Zm4.6-2.7,1.531,2.454-.9.56a.891.891,0,0,0,.27,1.624l3.392.785a.594.594,0,0,0,.713-.446l.781-3.393a.891.891,0,0,0-1.339-.956l-.9.564L12.521-14.95a3.563,3.563,0,0,0-6.041,0l-.275.439a1.192,1.192,0,0,0,.375,1.633,1.189,1.189,0,0,0,1.637-.373l.276-.441A1.188,1.188,0,0,1,10.506-13.695Zm7.949,8.251-.63-1.012a1.186,1.186,0,0,0-1.634-.379A1.189,1.189,0,0,0,15.812-5.2l.63,1.008a1.188,1.188,0,0,1-1.007,1.818H11.873V-3.439a.891.891,0,0,0-1.52-.63L7.889-1.6a.6.6,0,0,0,0,.84L10.354,1.7a.89.89,0,0,0,1.52-.63V0H15.43A3.562,3.562,0,0,0,18.454-5.444Z"
          transform="translate(0 16.625)"
        />
      </svg>
    ),
    seed: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16.625">
        <path
          d="M2.375-13.1H0A8.311,8.311,0,0,0,8.313-4.783v4.75A1.193,1.193,0,0,0,9.467,1.188,1.243,1.243,0,0,0,10.688,0V-4.75A8.342,8.342,0,0,0,2.375-13.1Zm14.25-2.342a8.31,8.31,0,0,0-7.266,4.279A9.46,9.46,0,0,1,11.548-7.17,8.315,8.315,0,0,0,19-15.437Z"
          transform="translate(0 15.438)"
        />
      </svg>
    ),
  };

  return icons[name];
}
